import { ItemType } from '@vista-digital/ocapi-types/v1';
import { isRecipeItemSupported } from './recipe-item-utils';
export const isItemSupported = (item) => {
    switch (item.type) {
        case ItemType.Normal:
        case ItemType.ParentSales:
            return true;
        case ItemType.Recipe:
            return isRecipeItemSupported(item);
        default:
            return false;
    }
};
